import EzController from 'controllers/ez-base-controller';
import { triggerCustomEvent, splitTestEnabled } from 'lib/helpers';
import { ajaxGet } from 'lib/ajax-helpers';

export default class FeaturedGridController extends EzController {
  trendingPage = 1;

  connect() {
    if (splitTestEnabled('homepage-trending')) {
      this.setupTrendingCollections();
    }

    this.flagLoaded();
  }

  disconnect() {
    if (splitTestEnabled('homepage-trending')) {
      this.loadMoreButton.removeEventListener('click', this.loadMoreTrending);
    }
  }

  setupTrendingCollections() {
    this.trendingItemsPerPage = this.element.dataset.resourcesPerPage;
    this.loadMoreButton.addEventListener('click', this.loadMoreTrending);
    this.gridContainer = this.element.querySelector('.ez-resource-grid');
    this.totalCollectionItemPages = parseFloat(this.element.dataset.totalCollectionItems) / this.trendingItemsPerPage;

    this.checkLoadMoreButton();
  }

  loadMoreTrending = () => {
    this.loadMoreButton.classList.add('has-spinner');
    this.trendingPage += 1;

    ajaxGet('/homepage_trending_content',
      (response) => {
        this.insertAjaxResources(response);
        this.loadMoreButton.classList.remove('has-spinner');
      },
      (error) => {
        console.error(error); // eslint-disable-line no-console
      },
      { params: { page: this.trendingPage } });
  }

  insertAjaxResources = (res) => {
    const resultsBody = document.createElement('DIV');
    resultsBody.innerHTML = res.data;
    const resultsItems = resultsBody.querySelectorAll('ul.ez-resource-grid li');
    const resultsContribIds = resultsBody.querySelector('[data-thumbnail-contributor-info-target="contribInfoTemplate"]').dataset.userIds;

    if (resultsItems.length) {
      resultsItems.forEach((item) => { this.trendingResults.appendChild(item); });
    }

    if (resultsContribIds) {
      this.addNewContributorIds(JSON.parse(resultsContribIds));
    }

    this.updateGridItems();
  }

  updateGridItems() {
    window.ezResourceGrid({
      gridSelector: this.gridContainer,
      options: {
        truncate: !!this.element.querySelector('.ez-resource-grid').getAttribute('data-truncate-results'),
      },
    });

    const gridItems = this.element.querySelectorAll('.ez-resource-grid__item');
    gridItems.forEach((item, index) => {
      item.setAttribute('data-position', index + 1);
    });

    this.checkLoadMoreButton();

    triggerCustomEvent('setNewThumbnailContributorInfo');
  }

  checkLoadMoreButton() {
    if (this.trendingPage > this.totalCollectionItemPages) {
      this.loadMoreButton.style.display = 'none';
    }
  }

  addNewContributorIds = (ajaxIds) => {
    const contribInfoTemplate = this.element.querySelector('[data-thumbnail-contributor-info-target="contribInfoTemplate"]');

    const oldIds = JSON.parse(contribInfoTemplate.dataset.userIds);
    const newIds = new Set([...oldIds, ...ajaxIds]);

    contribInfoTemplate.setAttribute('data-user-ids', JSON.stringify(newIds));
  }

  get trendingResults() {
    return this.element.querySelector('.home-trending-grid ul.ez-resource-grid');
  }

  get featuredGridItems() {
    return this.element.querySelectorAll('.ez-resource-thumb__link');
  }

  get loadMoreButton() {
    return this.element.querySelector('.load-more-button');
  }
}
